interface PriorityOptionProps {
  label: string
  iconSrc?: string
  selected: boolean
  disabled?: boolean
  onToggle: () => void
}

export function PriorityOption({
  label,
  iconSrc,
  selected,
  disabled,
  onToggle,
}: PriorityOptionProps) {
  return (
    <button
      type="button"
      className="vote-option"
      data-selected={selected}
      aria-pressed={selected}
      disabled={disabled}
      onClick={onToggle}
    >
      {iconSrc ? <img src={iconSrc} alt="" loading="lazy" decoding="async" /> : null}
      <span>{label}</span>
    </button>
  )
}
